const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
  } catch (err) {
    console.log(`Error: ${err}`);
  }
};
export default copyToClipBoard;
